<template>
<v-card flat>
<v-timeline dense clipped >
  <v-slide-x-transition group >
    <v-timeline-item
      v-for="(event, index) in timeline"
      :key="event.time"
      class="mb-0 pb-0"
      :icon="event.icon"
      :color="event.color || 'pink'"
      small >
        <v-list-tile >
          <v-list-tile-content>
            <v-list-tile-title v-if='event.message' >{{event.message}}</v-list-tile-title>
            <v-list-tile-sub-title v-if='event.time' >
              {{ dateformat(event.time.replace('%20', '+'), 'HH:mm:ss') }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
    </v-timeline-item>
  </v-slide-x-transition>
</v-timeline >
</v-card>
</template>
<script>
export default {
  name: 'AsyncActionList',
  props: {
    objectId: {
      type: String,
      description: 'The objectID to listen for events on'
    }
  },
  computed: {
    timeline () {
      return this.$store.getters.getAsyncMessagesById('foo')
    }
  }
}
</script>



// WEBPACK FOOTER //
// AsyncActionList.vue?6869f723